// ==========================
//=Site Load
// ==========================
document.addEventListener("DOMContentLoaded", function () {

	document.documentElement.classList.add('smooth-scroll');

	const cover = document.querySelector('.section--red-paper-cover');

	window.addEventListener("load", function () {

		if (document.querySelectorAll('.js-microsite-anchor-link').length) {

			document.querySelectorAll('.js-microsite-anchor-link').forEach(function (el) {

				el.style.pointerEvents = 'auto';

			});

		}

		if (cover)
			cover.classList.add('reading');

		timelineHeights();

		whereInScrollAreWe();

		if (document.querySelectorAll('.timeline-carousel').length) {

			document.querySelectorAll('.timeline-carousel').forEach(function (el) {

				var flkty = new Flickity(el);
				flkty.resize()

			});

		}

	});

});

// ==========================
// =Set the timeline heights and line position
// ==========================

jQuery(window).on('debouncedresize', timelineHeights);

function timelineHeights() {

	if (document.querySelectorAll('.js-timeline').length) {

		document.querySelectorAll('.js-timeline').forEach(function (el) {

			let imgs = el.getElementsByTagName('img'),
				len = imgs.length,
				counter = 0;

			[].forEach.call(imgs, function (img) {
				if (img.complete)
					incrementCounter();
				else
					img.addEventListener('load', incrementCounter, false);
			});

			function incrementCounter() {
				counter++;
				if (counter === len) {
					runTopHeights();
				}
			}

			function runTopHeights() {
				const nodelist = el.querySelectorAll('.js-timeline-top');
				const line = el.querySelector('#js-timeline-line');
				const tops = [].slice.call(nodelist);

				const tallest = Math.max.apply(Math, tops.map(function (elem, index) {
					elem.style.height = '';
					return elem.offsetHeight;
				}));

				tops.forEach(function (top) {
					top.style.height = tallest + 'px';
				});

				line.style.top = tallest - 1 + "px";
				line.style.opacity = 1;

			}

		});

	}
}

// ==========================
//=Add active state to nav items onclick
// ==========================

document.addEventListener("click", function (event) {

	if (!event.target.matches('.js-microsite-nav-link')) return;

	document.querySelectorAll('.js-microsite-nav-link').forEach(function (el) {
		el.classList.remove('reading');
	});

	event.target.classList.add('reading');

});

// ==========================
// =Open Menu
// ==========================

document.addEventListener("click", function (event) {

	const menu = document.querySelector('.nav--vertical');

	if (true == mobileWidth()) {

		if (event.target.matches('#js-clickable-toggle')) {

			event.preventDefault();
			menu.classList.add('expand');

		} else {

			menu.classList.remove('expand');

		}

	}

});

// ==========================
// =Scrollto
// ==========================

document.addEventListener("DOMContentLoaded", function (event) {

	window.addEventListener("load", function (e) {

		const menu = document.querySelector('.nav--vertical');

		let fadeAnimations = document.querySelectorAll('.js-animated');

		function getSamePageAnchor(link) {

			if (
				link.protocol !== window.location.protocol ||
				link.host !== window.location.host ||
				link.pathname !== window.location.pathname ||
				link.search !== window.location.search
			) {
				return false;
			}

			return link.hash;
		}

		// Scroll to a given hash, preventing the event given if there is one
		function scrollToHash(hash, e) {

			let currentReading = document.querySelector('article.reading');

			let elem = hash ? document.querySelector(hash) : false;

			if (elem) {

				if (!e) return;

				e.preventDefault();

				let timing = 1.8;

				document.documentElement.classList.remove('smooth-scroll');

				if (true == mobileWidth()) {
					menu.classList.add('hide');
					menu.classList.remove('expand');
				}

				fadeAnimations.forEach(anim => {

					if (!e.target.classList.contains('js-splash-link') && e.target.id != 'js-hero-anchor-link') {

						if (((anim.closest('article').getAttribute('id') !== elem.id && !anim.classList.contains('reading')) ||
							(!anim.classList.contains('reading') && anim.classList.contains('article-sections-wrapper'))) &&
							!elem.contains(anim))
							anim.classList.remove('animatedFadeInUp');

					}

				});

				if (e.target.id == 'js-hero-anchor-link' ||
					e.target.classList.contains('js-splash-link') ||
					e.target.classList.contains('title'))
					timing = .8;

				if (e.target.classList.contains('js-splash-link') && null != document.querySelector(hash).nextElementSibling)
					elem = document.querySelector(hash).nextElementSibling;

				if (!e.target.classList.contains('js-splash-link'))
					elem.classList.add('reading');

				let ms = timing * 1000;

				setTimeout(function () {

					if (elem.querySelectorAll('.js-animated').length) {

						let landing = elem.querySelectorAll('.js-animated');

						if (landing.length) {
							landing[0].classList.add('fadeInUp');
						}

					}

				}, ms);

				gsap.to(window, { duration: timing, scrollTo: { y: elem }, ease: Power3.easeInOut, onComplete: afterScrolling });

			}

		}

		// If a link's href is within the current page, scroll to it instead
		document.querySelectorAll('.js-microsite-anchor-link[href]').forEach(a => {

			a.addEventListener('click', e => {

				scrollToHash(getSamePageAnchor(a), e);

			});

		});

		// Scroll to the element in the URL's hash on load
		scrollToHash(window.location.hash);

	}, false);

});


function afterScrolling() {

	document.querySelectorAll('.js-animated').forEach(anim => {
		anim.classList.add('animatedFadeInUp');
	});

	setTimeout(function () { document.documentElement.classList.add('smooth-scroll'); }, 600);

};

// ==========================
// =Active state based on viewport
// ==========================

jQuery(window).on('scroll', $.debounce(150, whereInScrollAreWe));

function whereInScrollAreWe() {

	const menu = document.querySelector('.nav--vertical');

	if (document.querySelectorAll('.js-microsite-pos').length) {

		document.querySelectorAll('.js-microsite-pos').forEach(function (el) {

			let position, eLink;

			position = isVisible(el);

			if (el.nodeName == 'ARTICLE') {

				elLink = document.querySelector('.microsite-nav-link[href="#' + el.id + '"]');

				if ('top' == position) {

					el.classList.add('reading');

					if (menu.classList.contains('hide'))
						menu.classList.remove('hide');

					if (elLink)
						elLink.classList.add('reading');

				}

				else {

					el.classList.remove('reading');

					if (elLink)
						elLink.classList.remove('reading');

				}

			}

			if (el.nodeName != 'ARTICLE') {

				if ('onScreen' == position || 'top' == position) {

					el.classList.add('reading');

					if (el.classList.contains('js-animated'))
						el.classList.add('fadeInUp');

				} else {

					el.classList.remove('reading');

					if (el.classList.contains('js-animated'))
						el.classList.remove('fadeInUp');

				}

			}

		});

	}

}

// ==========================
// =Utilities
// ==========================

//Check visibility
function isVisible(ele) {

	let { top, bottom } = ele.getBoundingClientRect();
	const vHeight = (window.innerHeight || document.documentElement.clientHeight);

	top = Math.round(top);
	bottom = Math.round(bottom);

	let position = false;

	if ((top <= 10 && bottom > 10) &&
		top < vHeight) {
		position = 'top';
	} else if (top >= 0 && top < vHeight) {
		position = 'onScreen';
	}

	return position;

}

//Check our width
function mobileWidth() {

	const lgStr = getComputedStyle(document.documentElement).getPropertyValue('--break-lg');
	const lg = parseInt(lgStr, 10);
	let w = window.innerWidth;

	if (w < lg)
		return true;

	return false;

}
